import { render, staticRenderFns } from "./GrantType.vue?vue&type=template&id=1872e92b&"
import script from "./GrantType.vue?vue&type=script&lang=js&"
export * from "./GrantType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports